import React, {
  useEffect,
  useState,
} from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import {
  FaFilePdf,
  FaDownload,
} from "react-icons/fa";

const CbseDocuments = () => {
  const [open, setOpen] =
    useState(false);

  const [data, setData] =
    useState([]);

  useEffect(() => {
    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/cbse-documents"
    )
      .then((res) =>
        res.json()
      )
      .then(setData);
  }, []);

  /* DOWNLOAD */
  const handleDownload =
    async (
      file,
      title
    ) => {
      const url = `https://stjosephweb.ilakshyaerp.in/uploads/cbse/${file}`;

      const response =
        await fetch(url);

      const blob =
        await response.blob();

      const link =
        document.createElement(
          "a"
        );

      link.href =
        window.URL.createObjectURL(
          blob
        );

      link.download =
        title || file;

      document.body.appendChild(
        link
      );

      link.click();

      link.remove();
    };

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* HERO */}
      <section className="bg-[#072F5F] py-16">

        <div className="max-w-7xl mx-auto px-5 text-center">

          <h1 className="text-4xl md:text-5xl font-extrabold text-white">

            CBSE REQUIRED DOCUMENTS

          </h1>

          <div className="w-28 h-1 bg-[#D4A017] mx-auto rounded-full mt-5"></div>

        </div>

      </section>

      {/* DOCUMENT SECTION */}
      <section className="bg-[#f5f7fb] py-16 min-h-screen">

        <div className="max-w-7xl mx-auto px-5 md:px-10">

          {data.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-8 gap-y-14 justify-items-center">

              {data.map((d) => (
                <div
                  key={d.id}
                  className="flex flex-col items-center text-center group w-full max-w-[220px] min-h-[320px]"
                >

                  {/* PDF ICON */}
                  <div
                    onClick={() =>
                      handleDownload(
                        d.file,
                        d.title
                      )
                    }
                    className="cursor-pointer transition-all duration-300 group-hover:-translate-y-2"
                  >

                    <div className="relative">

                      {/* PAPER */}
                      <div className="w-[110px] h-[135px] bg-white rounded-md shadow-lg border border-gray-200 relative overflow-hidden">

                        {/* TOP CORNER */}
                        <div className="absolute top-0 right-0 w-0 h-0 border-l-[28px] border-l-transparent border-b-[28px] border-b-[#e5e7eb]"></div>

                        {/* PDF ICON */}
                        <div className="flex items-center justify-center pt-7">

                          <FaFilePdf className="text-red-600 text-6xl" />

                        </div>

                        {/* PDF BAR */}
                        <div className="absolute bottom-0 left-0 w-full bg-red-600 py-1">

                          <span className="text-white font-bold text-lg">

                            PDF

                          </span>

                        </div>

                      </div>

                    </div>

                  </div>

                  {/* TITLE */}
                  <h3 className="mt-4 text-[15px] font-semibold text-[#0B4F9C] leading-6 uppercase h-[72px] flex items-start justify-center text-center px-2">

                    {d.title}

                  </h3>

                  {/* DOWNLOAD BUTTON */}
                  <button
                    onClick={() =>
                      handleDownload(
                        d.file,
                        d.title
                      )
                    }
                    className="mt-auto flex items-center gap-2 bg-[#0B4F9C] hover:bg-[#072F5F] text-white px-5 py-2 rounded-lg text-sm font-semibold transition-all duration-300 shadow-md hover:shadow-xl"
                  >

                    <FaDownload />

                    Download

                  </button>

                </div>
              ))}

            </div>
          ) : (
            <div className="bg-white rounded-3xl shadow-lg p-16 text-center">

              <FaFilePdf className="text-6xl text-red-600 mx-auto mb-6" />

              <h3 className="text-3xl font-bold text-[#072F5F]">

                No Documents Available

              </h3>

              <p className="text-gray-500 mt-4">

                Documents will be uploaded soon.

              </p>

            </div>
          )}

        </div>

      </section>

      <Footer />
    </>
  );
};

export default CbseDocuments;